import React from 'react';
const Block = function ({ children, className, id }) { return /*#__PURE__*/ React.createElement("div", { className: `block${className ? ` ${className}` : ''}`, id: id }, children); };
export default Block;
